import { PlantState } from "@app/api/plants";

export interface PlantValidationState {
  loading: boolean;
  completedFirstLoad: boolean;
  error: boolean;
  errorMessage?: string | undefined;
  data: PlantState
}

export const initialPlantState = {
  loading: false,
  completedFirstLoad: false,
  error: false,
  errorMessage: undefined,
  data: {
    general: false,
    calculationModes: {
      tappingMode: false,
      ladleFurnaceMode: false,
    },
    equipment: {
      ladle: false,
      ladleFurnace: false
    },
    additions: {
      fluxes: false,
      alloys: false,
      slagDeoxidizers: false,
    },
    carryoverSlag: {
      inference: false,
      composition: false,
    },
    steelGrade: {
      category: false
    }
  }
}